module.exports = __webpack_public_path__ + "assets/devices/WiredZone-212c4c241ece690c57abf210bfcd1899.svg";